import { Image, Text, View } from "@react-pdf/renderer"
import { ImageType } from "../../interfaces/intakes.reports"

interface Props {
    images: ImageType[]
}
export const PDFImages = ({ images }: Props) => {

    return (
        <View style={{
            flex: 1,
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            marginHorizontal: "auto",
            alignItems: 'center',
            width: "100%",
            gap: '4px',
        }}>

            {images.map(image => (

                <View key={image.key} style={
                    { width: "24.5%", maxHeight: "160px", alignItems: 'center', justifyContent: 'center' }
                    // isBatchImages
                    // ? { width: "19%", maxHeight: "160px", alignItems: 'center', justifyContent: 'center' }
                    // : { width: "24.5%", maxHeight: "160px", alignItems: 'center', justifyContent: 'center' }
                    }>
                    <Image
                        src={ image.imgURL || image.imgURL_low}
                        style={{ width: "100%", objectFit: 'contain' }}
                    />
                </View>
            ))}

        </View>
    )
}
